const WordNotFound = () => {
  return (
    <div className='notfound'>
      <h2>Word not found.</h2>
    </div>
  )
}

export default WordNotFound